function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
import tscStyles from '../constants/TscStyles';
import mediaQueryBreakpoints from '../constants/MediaQueryBreakpoints';
import ControlButton from '../ControlButton/ControlButton';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
import TscButtonType from '../constants/TscButtonType';
var scrollableContentBorderColor = tscStyles.color.ui.dawn.lightMedium;
var Container = styled.div.withConfig({
  displayName: "ScrollableTextPrompt__Container"
})(["width:", ";margin:0 auto;padding:1rem;background-color:", ";box-shadow:0 0 5rem 0.1rem rgba(0,0,0,.1);border-radius:", ";box-sizing:border-box;"], function (props) {
  return props.promptWidth;
}, tscStyles.color.ui.dawn.lightMedium, tscStyles.border.radius.sm);
var Title = styled.h2.withConfig({
  displayName: "ScrollableTextPrompt__Title"
})(["color:", ";font-size:1.25rem;font-weight:bold;margin:0 0 .5rem;"], tscStyles.color.text.dark);
var Description = styled.p.withConfig({
  displayName: "ScrollableTextPrompt__Description"
})(["color:", ";margin:0;padding-bottom:1rem;"], tscStyles.color.text.dark);
var ScrollableContent = styled.div.withConfig({
  displayName: "ScrollableTextPrompt__ScrollableContent"
})(["text-align:justify;height:", ";overflow-y:scroll;color:", ";background-color:", ";border:1px solid ", ";padding:.5rem;margin-bottom:1rem;pre{white-space:pre-wrap;margin:0;}"], function (props) {
  return props.textBoxHeight;
}, tscStyles.color.text.dark, tscStyles.color.ui.dawn.lightMedium, scrollableContentBorderColor);
var ButtonContainer = styled.div.withConfig({
  displayName: "ScrollableTextPrompt__ButtonContainer"
})(["display:flex;flex-direction:column;justify-content:space-around;width:100%;a,button{margin-bottom:.5rem;}@media(min-width:", "){flex-direction:row;a,button{flex-grow:1;flex-shrink:1;flex-basis:0px;}a:nth-child(2),button:nth-child(2){margin-left:1rem;}}"], mediaQueryBreakpoints.mobile);

var ScrollableTextPrompt = function ScrollableTextPrompt(_ref) {
  var btn1Handler = _ref.btn1Handler,
      btn1Href = _ref.btn1Href,
      btn1Label = _ref.btn1Label,
      btn1MustScrollToBottom = _ref.btn1MustScrollToBottom,
      _ref$btn1ThemeName = _ref.btn1ThemeName,
      btn1ThemeName = _ref$btn1ThemeName === void 0 ? TscThemeName.dawn : _ref$btn1ThemeName,
      _ref$btn1Type = _ref.btn1Type,
      btn1Type = _ref$btn1Type === void 0 ? TscButtonType.secondary : _ref$btn1Type,
      btn2Handler = _ref.btn2Handler,
      btn2Href = _ref.btn2Href,
      btn2Label = _ref.btn2Label,
      btn2MustScrollToBottom = _ref.btn2MustScrollToBottom,
      _ref$btn2ThemeName = _ref.btn2ThemeName,
      btn2ThemeName = _ref$btn2ThemeName === void 0 ? TscThemeName.dawn : _ref$btn2ThemeName,
      _ref$btn2Type = _ref.btn2Type,
      btn2Type = _ref$btn2Type === void 0 ? TscButtonType.secondary : _ref$btn2Type,
      className = _ref.className,
      _ref$contentTextOrEle = _ref.contentTextOrElement,
      contentTextOrElement = _ref$contentTextOrEle === void 0 ? '' : _ref$contentTextOrEle,
      description = _ref.description,
      _ref$promptWidth = _ref.promptWidth,
      promptWidth = _ref$promptWidth === void 0 ? '100%' : _ref$promptWidth,
      _ref$textBoxHeight = _ref.textBoxHeight,
      textBoxHeight = _ref$textBoxHeight === void 0 ? '18.75rem' : _ref$textBoxHeight,
      title = _ref.title;

  var _React$useState = React.useState({
    hasScrolledToBottom: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _scrollableContentRef = React.useRef(null);

  var _onScrollHandler = function _onScrollHandler() {
    if (state.hasScrolledToBottom || !contentTextOrElement) {
      return;
    }

    var element = _scrollableContentRef.current;

    if (element && element.scrollHeight - element.scrollTop === element.clientHeight) {
      setState({
        hasScrolledToBottom: true
      });
    }
  }; // Execute the onScroll event handler once on mount in case there is nothing for the user to scroll.


  React.useEffect(function () {
    _onScrollHandler(); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []); // execute on mount

  var _renderBtn = function _renderBtn(themeName, type, label, href, onClick, mustScrollToBottom, btnClassName) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!label || !themeName || !type) {
      return null;
    }

    return _jsx(ControlButton, {
      className: btnClassName,
      label: label,
      themeName: themeName,
      buttonType: type,
      href: href,
      onClick: onClick,
      disabled: !state.hasScrolledToBottom && mustScrollToBottom
    });
  };

  return _jsxs(Container, {
    className: getClassName(className, null, 'scrollable-text-prompt'),
    promptWidth: promptWidth,
    children: [_jsx(Title, {
      className: getClassName(className, 'title', 'scrollable-prompt-title'),
      children: title
    }), _jsx(Description, {
      className: getClassName(className, 'description', 'scrollable-prompt-description'),
      children: description
    }), contentTextOrElement && _jsx(ScrollableContent, {
      className: getClassName(className, 'scrollable-content'),
      textBoxHeight: textBoxHeight,
      ref: _scrollableContentRef,
      onScroll: _onScrollHandler,
      children: _jsx("pre", {
        children: contentTextOrElement
      })
    }), _jsxs(ButtonContainer, {
      className: getClassName(className, 'button-container', 'scrollable-buttons-container'),
      children: [_renderBtn(btn1ThemeName, btn1Type, btn1Label, btn1Href, btn1Handler, btn1MustScrollToBottom, "".concat(getClassName(className, 'first-button'))), _renderBtn(btn2ThemeName, btn2Type, btn2Label, btn2Href, btn2Handler, btn2MustScrollToBottom, "".concat(getClassName(className, 'second-button')))]
    })]
  });
};

var ScrollableTextPromptTest = {
  Container: Container
};
export { ScrollableTextPrompt, ScrollableTextPromptTest };
export default ScrollableTextPrompt;